var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLubanseat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "standerd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#52E5FF ",
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1309_copy_2",
    fill: "#52E5FF ",
    points: "18.86 21 2 21 2 13 4.139 13 4.139 19 18.859 19 18.859 13 21 13 21 21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubanseat);
export default __webpack_public_path__ + "static/media/lubanseat.35853d8381cfd0ca6b44eee55d0a9f81.svg";
export { ForwardRef as ReactComponent };